/**
* comunicator
* 3.0.1
*
* The 720kb notifier api (atm it uses websockets)
* https://github.com/720kb/comunicator
*
* MIT license
* Sun Mar 06 2016
*/
/*global module*/
module.exports = ({connectedSockets = new Map()}) => ({
  'isUserPresent': who => {

    return connectedSockets.has(who);
  }
});
